

<div class="modal-body m-1  justify-content-left">
  <div>
  <ul class="nav nav-pills nav-fill">
    <li class="nav-item" >
      <a class="nav-link" [class.active]="tabIndex==1" href="javascript:void(0);" (click)="setTabIndex(1)">Attachments</a>
    </li>
    <li *ngIf="!isReadOnly" class="nav-item" >
      <a class="nav-link" [class.active]="tabIndex==2" href="javascript:void(0);" (click)="setTabIndex(2)">Upload File</a>
    </li>

  </ul>
  </div>

  <div *ngIf="tabIndex==1" class="w-100 mt-3">
    <table class="table">

      <tr>
        <th>File Name</th>

        <th>Uploaded By</th>
        <th>Upload Date</th>
        <th>Comment</th>
      </tr>
      <tr  *ngFor="let f of observationFiles">
        <td>
          <div class="btn-group m-1" role="group">
            <button  type="button" class="btn btn-info" (click)="viewAttachement(f)" >
              <i class="fas fa-paperclip text-primary"></i> {{f.fileName}}
            </button>
            <button type="button" class="btn btn-info" *ngIf="isMyAttachment(f) && !isReadOnly" (click)="deleteAttachement(f)"> <i class="fas fa-trash-alt" style="color: #ba1717;"></i></button>
          </div>
        </td>
        <td>{{f.displayName}}</td>
        <td>{{f.uploadDate | date}}</td>
        <td>{{f.commentLabel}}</td>
      </tr>
    </table>

  </div>
  <div *ngIf="tabIndex==2" class="w-100 mt-3">
    <div class="row m-3">
      <form [formGroup]="form" (ngSubmit)="submit(form)">
          <div class="form-group">

                  Files are limited to:<br>
                      <ul>
                          <li>-20 MB size</li>
                          <li>-Standard documents (PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, RTF), images (JPG, PNG, JPEG, GIF), and audio files ( WAV, M4A, MP3)</li>
                      </ul>
              <div class="alert alert-danger" role="alert" *ngIf="invalidFile">
                The file is larger than the file size limit or is an invalid type. Please select a different file.
              </div>
              <input type="file" class="form-control h-auto" placeholder="Upload Document" accept=".gif,.jpg,.jpeg,.tiff,.png,.doc,.docx,.xls,.xlsx,.pdf,.txt,.rtf,.ppt,.pptx,.m4a,.mp3,.wav,.aac"
                  (change)="onChange($event)"/>

          </div>


          <div class="form-group">
              <button type="submit" class="btn btn-primary" [disabled]="form.invalid" [ladda]="busy">Upload</button>
          </div>
      </form>
  </div>
</div>
<div class="modal-footer">

  <button type="button" class="btn btn-info" (click)="close()">Close</button>
</div>

